<template>
  <div>
    <addSoundtrack></addSoundtrack>
  </div>
</template>

<script>
import addSoundtrack from "@/components/subtitle/soundtrack/addSoundtrack.vue";

export default {
  name: "soundtrackDialog",
  props: {},
  components: {
    addSoundtrack,
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/subtitle/dialogs/soundtrackDialog.vue